import { Injectable } from "@angular/core";
import { OnPremiseSyncDataState } from "./on-premise-sync-state.service";
import { concatMap, map, mergeMap, Observable, of, Subject, tap, toArray } from "rxjs";
import { toInspectionDetailNew } from "../sync-mapper";
import { Inspection, InspectionLocation } from "../../../_objects/inspection";
import { InspectionSchema } from "../../../_offline/models/inspection.schema";
import { InspectionDbService } from "../../database/inspection-db.service";
import { InspectionService } from "../../http-api/inspection.service";
import { LoginUserService } from "../../http-api/login-user.service";
import { InspectionImageDbService } from "../../database/inspection-image-db.service";

@Injectable({
  providedIn: "root"
})
export class InspectionFirstSyncService {
  constructor(
    private syncState: OnPremiseSyncDataState,
    private inspectionDbService: InspectionDbService,
    private inspectionService: InspectionService,
    private loginUserService: LoginUserService,
    private inspectionImageDbService: InspectionImageDbService
  ) {}

  createInspections(): Observable<unknown> {
    return this.inspectionDbService.getAllOnPremise().pipe(
      concatMap((inspection) => inspection),
      mergeMap((inspection) => this.createInspection(inspection)),
      toArray()
    );
  }

  deleteInspections() {
    return this.inspectionDbService.getAllOnPremise().pipe(
      concatMap((inspection) => inspection),
      mergeMap((inspection) => this.inspectionDbService.deleteInspection(inspection.id, false).pipe(map(() => ({ id: inspection.id })))),
      mergeMap((result) => this.inspectionImageDbService.deleteALL(result.id, false)),
      toArray()
    );
  }

  private createInspection(inspection: InspectionSchema) {
    const userId = this.loginUserService.loginUser.id;
    const effectiveId = inspection.liveAssetId ?? inspection.subjectId;
    const subjectId = this.syncState.getSubjectId(effectiveId) ?? effectiveId;
    const newInspection = toInspectionDetailNew(inspection, subjectId, userId);

    return this.inspectionService.addInspection(newInspection).pipe(
      tap((created) => this.syncState.updateInspection(created.id, inspection.id)),
      mergeMap(() => this.createLocationSummary(inspection.id))
    );
  }

  private createLocationSummary(inspectionId: string) {
    return this.inspectionDbService.getInspection(inspectionId, true, this.syncState.getOnPremiseTenantId()).pipe(
      mergeMap((inspectionDetails) => {
        const locations = inspectionDetails?.inspectionLocations ? (JSON.parse(inspectionDetails.inspectionLocations) as InspectionLocation[]) : [];
        const createdInspectionId = this.syncState.getInspectionId(inspectionId);
        return this.inspectionService.updateInspectionLocations({ inspectionId: createdInspectionId, inspectionLocations: locations });
      })
    );
  }
}
